import { deleteIndexFromArray } from "helpers/deleteIndexFromArray";

export const dashData = (state={name:'-', imgUrl:1, secondReceived:false}, action) => {

  switch(action.type){
    case 'LOAD_DASH_DATA':
      if(action.payload!==undefined){
        return action.payload
      }else{
        return state
      }

    case 'UPDATE_DASH_DATA':  {
      state[action.key]=action.payload;
      return state
    }
    case 'UPDATE_DASH_CLASSNAME':  {
      state.classes[action.classIndex].className=action.payload;
      return state
    }

    case 'CREATE_NEW_CLASS':
      const newClass = {
        classId: '',
        className: action.className,
        numberStudents: 0,
        activities: []
      }
      state.classes.unshift(newClass)
      return state;

    
    case 'DELETE_ACTIVITY_DASH':
      state.classes[action.classIndex].activities.splice(action.activityIndex, 1)
    return state; 
  
    case 'DUPLICATE_CLASS':
      const duplicate = {...state.classes[action.classIndex]}
      return {
        ...state,
        classes:[duplicate, ...state.classes]
      };

    case 'ARCHIVE_CLASS':
      const item = state.classes[action.classIndex];
      item.archived=true;
      return{
        ...state,
        archivedClasses:state.archivedClasses ? [...state.archivedClasses, item] : [item],
        classes: deleteIndexFromArray(state.classes, action.classIndex)
      }

    case 'UNARCHIVE_CLASS':
      const archiveItem = state.archivedClasses[action.classIndex];
      archiveItem.archived=false;
      return {
          ...state,
          archivedClasses: deleteIndexFromArray(state.archivedClasses, action.classIndex),
          classes:[archiveItem, ...state.classes]
        };

      case 'DELETE_CLASS':
        state.classes.splice(action.classIndex, 1);
        // return state;
        return {
            ...state,
            classes:deleteIndexFromArray(state.classes, action.classIndex)
          };

    default:
      return state
  }
}


export const chatData = (state={incomingMessage:null, unreadCount:0}, action) =>{

  switch(action.type){
    case 'INCOMING_MESSAGE':
      return { 
        ...state, 
        incomingMessage: action.payload
      }
    case 'UNREAD_MESSAGE':
      return { 
        ...state, 
        unreadCount: state.unreadCount+1
      }
    case 'SET_UNREAD':
      return { 
        ...state, 
        unreadCount: action.payload
      }
    default:
      return state
  }
}

export const activeClass = (state=0, action) =>{
  
  switch(action.type){

      case 'ACTIVE_CLASS':
        return action.payload
      default:
        return state
  }
}

export const currentActivity = (state=0, action) =>{
  
  switch(action.type){
      case 'CURRENT_ACTIVITY':
        return action.payload

      case 'UPDATE_KEY':
        return {...state, [action.key]: action.payload}

      default:
        return state
  }
}

export const selectedSection = (state=0, action) => {
  switch(action.type){

    case 'SWITCH_SELECTED_SECTION':
      return action.payload

      default:
        return state
  }
}

export const radVal  = (state='one', action) => {
  switch(action.type){

    case 'SET_RADVAL':
      return action.payload

    default:
      return state
    
  }
}

export const fetchedClass = (state={data:'initial'}, action) => {
  switch(action.type){
    

    case 'FETCH_CLASS':
      if(action.payload!==undefined){
        return action.payload
      }else{
        return state
      }

    case 'UPDATE_CLASS_KEY':
      state[action.key]=action.value;
      return state;

    case 'UPDATE_CLASS_FOLDER':
      state.folders[action.folderKey].name=action.value;
      return state;


    case 'ADD_TO_FOLDER':
        state.folders[action.folderKey].items.push(action.newAct);
        return state;
  

    case 'REMOVE_FROM_FOLDER':
        state.folders[action.folderKey].items.splice(action.index, 1);
        return state;
  
    case 'ADD_NEW_ACTIVITY':
      if(state.activities=== 'initial'){state.activities=[]};
      state.activities.push(action.payload);
      return state

    case 'ARCHIVE_ACTIVITY':
      const actIndex = state.activities.findIndex(i => i.activityId === action.activityId)
      state.activities.splice(actIndex, 1);
      return state;
    
    case 'UNARCHIVE_ACTIVITY':
      if(state.activities === "initial"){state.activities=[]}
      state.activities.push(action.activity)
    return state;

    case 'DELETE_ACTIVITY':
      state[action.source].splice(action.activityIndex, 1)
    return state;

    case 'UPDATE_FETCHED_ACTIVITY':
      const index = state.activities.findIndex(x => x.activityId === action.activityId)

      state.activities[index][action.key] = action.value;
      return state;

    case 'CLEAR_DISPLAY_DATA':
      state =[];
      return state;

    default:
      return state;
    }
}

export const activityData = (state={}, action ) => {
  switch(action.type){

    case 'ADD_ACTIVITY_DATA':
      if(action.payload===undefined){
        return state
      }else{
        return action.payload
      }


    case 'UPDATE_ACTIVITY_KEY':
      state[action.key]=action.value;
      return state;

    case 'UPDATE_ACTIVITY_SECTION':
      return {
        ...state,
        sections:[
          ...state.sections.slice(0,action.sectionIndex),
          action.payload,
          ...state.sections.slice(action.sectionIndex+1),
        ]
      }

    case 'UPDATE_SECTION_KEY':
      console.log(state)
      console.log(action)
      state.sections[action.sectionIndex][action.key]=action.value;
      return state;


    case 'ADD_NEW_SECTION':
      state.sections.push(action.payload);
      return state
     

    case 'REMOVE_SECTION':
      state.sections.splice(action.sectionIndex,1);
      return state
 

    case 'ADD_WORD':
      state.sections[action.sectionIndex].wordBank.push(action.value);
      return state;

    case 'REMOVE_WORD':
      state.sections[action.sectionIndex].wordBank.map(
        (word, index) =>{
          if( index === action.wordIndex ){
            return[
              state.sections[action.sectionIndex].wordBank.splice(index,1)
            ]
          } else {return null}
        }
      );
      break;

      default:
        return state;
  }
}

